import { useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../context/AuthContext.jsx';
import { Field } from '../components/ui.jsx';
import { t } from '../i18n/index.jsx';
import TwoFactorSetup from '../components/TwoFactorSetup.jsx';
import TelegramLink from '../components/TelegramLink.jsx';

export default function Account() {
  const { user } = useAuth();
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(''); setMsg(null);
    if (next !== confirm) { setErr(t('New passwords do not match')); return; }
    if (next.length < 8) { setErr(t('New password must be at least 8 characters')); return; }
    setBusy(true);
    try {
      await api.post('/auth/change-password', { current_password: cur, new_password: next });
      setMsg(t('Password updated.'));
      setCur(''); setNext(''); setConfirm('');
    } catch (e2) {
      setErr(e2.message || t('Could not change password'));
    } finally { setBusy(false); }
  }

  return (
    <div className="page fade-in">
      <h1 className="page-title">{t('Account')}</h1>

      <div className="detail-grid" style={{ marginTop: 16 }}>
        <div className="kv"><span>{t('Name')}</span><b>{user.name}</b></div>
        <div className="kv"><span>{t('Email')}</span><b>{user.email}</b></div>
        <div className="kv"><span>{t('Role')}</span><b style={{ textTransform: 'capitalize' }}>{t(user.role)}</b></div>
      </div>

      <section className="panel" style={{ maxWidth: 460 }}>
        <h2 className="panel-title">{t('Change password')}</h2>
        {err && <div className="alert error">{err}</div>}
        {msg && <div className="alert success">{msg}</div>}
        <form onSubmit={submit}>
          {/* Hidden username so password managers associate the credential correctly. */}
          <input type="text" name="username" autoComplete="username" value={user.email} readOnly hidden />
          <Field label={t('Current password')}>
            <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} autoComplete="current-password" required />
          </Field>
          <Field label={t('New password')}>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" required />
          </Field>
          <Field label={t('Confirm new password')}>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required />
          </Field>
          <button className="btn primary" disabled={busy}>{busy ? t('Saving…') : t('Update password')}</button>
        </form>
      </section>

      <TwoFactorSetup />
      <TelegramLink />
    </div>
  );
}
